export const INSTALLER_TABLE_PAGE_SIZE = 10;

export const INSTALLER_TABLE_COLUMNS = ['installerName', 'installerId', 'email', 'appActivated', 'actions'];

export enum InstallerStatus {
  CONFIRMED = 'CONFIRMED',
  FORCE_CHANGE_PASSWORD = 'FORCE_CHANGE_PASSWORD',
}
